
import "@/styles/pages/kayinMaterial/index.less";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // 由 vitesse 转换

new Vue({
  created($, apower) {
    let authorization; // 请求接口参数 Token
    let data = []; // 素材库数据 用来遍历dom
    let datas = []; // 素材库数据 用来处理多选
    let obj = {}; // 多选
    let str1 = ""; // 遍历的列表div
    let page = 1; // 分页：第几页
    let per_page = 20; // 分页：一页几条数据
    let loading = true; // 是否加载完全部数据
    let timeOut = null; // 定时器

    // 监听用户是否登入
    apower.user.on("logined", isLogin, this);
    // 监听用户是否登出
    apower.user.on("logout", isLogin, this);
    // 滚动加载
    window.addEventListener("scroll", debounceFirstExe(onScroll, 500), true);

    isLogin();

    // 获取数据
    function getData() {
      $.ajax({
        //请求方式
        type: "GET",
        //同步请求
        async: false,
        data: {
          per_page,
          page,
        },
        //添加Token
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${authorization}`);
        },
        //请求地址
        url: "https://gw.aoscdn.com/app/casttingo/resources",
        //请求成功
        success: function (res) {
          data = res.data.result;
          datas.push.apply(datas, data);
          $(".km_set").css("display", "flex");
          setDom();
          setDomClick();
          if (datas.length === res.data.total) {
            loading = false;
          }
          if (data === undefined && str1 === "") {
            init();
            loading = false;
          }
        },
        //请求失败，包含具体的错误信息
        error: function (e) {
          console.log(e.status);
          console.log(e.responseText);
        },
      });
    }

    // 将数据放到dom上
    function setDom() {
      $.each(data, (index, item) => {
        str1 += `<div class="km_box">
                      <div class='km_item'>
                        <input class="km_chance" type="checkbox">
                        <a href="${item.url.original}" target="_blank"><img src="${item.url.original}"></a>
                      </div>
                      <div class='item_name' title="${item.original_name}">${item.original_name}</div>
                  </div>`;
      });
      $(".km_wrapper").html(str1);
      $(".km_item").height(($(".km_item").width() / 9) * 16); // 素材宽度初始化
      $(window).resize(() => {
        $(".km_item").height(($(".km_item").width() / 9) * 16); // 监听浏览器宽度变化改变素材宽度
      });
    }

    // 为dom添加click事件
    function setDomClick() {
      // 点击图片预览下载
      // $('.km_item > a').each(function (i, j) {
      //   $(this).on('click', function () {
      //     downloadImg($(j).attr('href'))
      //   })
      // })
      // 点击选择框
      $(".km_chance").each(function (i, j) {
        $(this).on("click", function () {
          $(j).prop("checked")
            ? (obj[i] = $(j).prop("checked"))
            : delete obj[i];
          $.isEmptyObject(obj)
            ? $(".km_btn").css("opacity", "0.7")
            : $(".km_btn").css("opacity", "1");
          // 手动选择当前所有图片则选中全选按钮
          Object.keys(obj).length === datas.length &&
            $(".km_all").prop("checked", true);
        });
      });
      // 点击下载按钮
      $(".km_btn")
        .off()
        .on("click", function () {
          if ($(".km_btn").css("opacity") === "1") {
            $(".km_btn").css("opacity", "0.7");
            $(".km_chance").css("display", "block");
            $(".km_choose").css("display", "flex");
          } else {
            $(".km_btn").css("opacity", "1");
            $(".km_chance").css("display", "none");
            $(".km_choose").css("display", "none");
          }
          !$.isEmptyObject(obj) && download();
        });
      // 点击全选按钮
      $(".km_all")
        .off()
        .on("click", function () {
          chooseAll();
        });
    }

    // 全选按钮
    function chooseAll() {
      // 全不选和全选之外的情况
      if (
        Object.keys(obj).length > 0 &&
        Object.keys(obj).length < datas.length
      ) {
        for (let i = 0; i < datas.length; i++) {
          if (!Object.keys(obj).includes(String(i))) {
            $(".km_chance").eq(i).click();
          }
        }
        // 全不选和全选
      } else {
        for (let i = 0; i < datas.length; i++) {
          $(".km_chance").eq(i).click();
        }
      }
    }

    // 下载图片
    function download() {
      getDownloadUrl().map((item) => {
        downloadImg(item);
      });
      // 下载时初始化
      $(".km_btn").css("opacity", "1");
      $(".km_chance").css("display", "none").prop("checked", false);
      $(".km_choose").css("display", "none");
      $(".km_all").prop("checked", false);
      obj = {};
    }

    // 获取要下载的url图片地址
    function getDownloadUrl() {
      let arr = Object.keys(obj);
      let downloadArr = [];
      arr.map((item) => {
        downloadArr.push(datas[item].url.original);
      });
      return downloadArr;
    }

    // 解决非同源url无法下载问题
    function downloadImg(src) {
      var x = new XMLHttpRequest(); //禁止浏览器缓存；否则会报跨域的错误
      x.open("GET", src + "?t=" + new Date().getTime(), true);
      x.responseType = "blob";
      x.onload = function (e) {
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = "";
        a.click();
      };
      x.send();
    }

    // 初始化无数据
    function init() {
      if (authorization) {
        str1 = `<div class="km_empty">暂无数据</div>`;
      } else {
        str1 = `<div class="km_empty">请登录!</div>`;
      }
      $(".km_set").css("display", "none");
      $(".km_wrapper").html(str1);
      $(".km_choose").css("display", "none");
      $(".km_all").prop("checked", false);
      datas = [];
      obj = {};
      str1 = "";
      page = 1;
      loading = true;
      timeOut = null;
    }

    // 判断用户是否登陆
    function isLogin() {
      authorization = apower.user.apiToken;
      if (apower.user.isLogined()) {
        getData();
      } else {
        init();
      }
    }

    // 防抖
    function debounceFirstExe(fn, delay) {
      // 定时器
      let timer = null;
      // 将debounce处理结果当作函数返回
      return function () {
        // 保留调用时的this上下文
        let context = this;
        // 保留调用时传入的参数
        let args = arguments;
        // 每次事件被触发时，都去清除之前的旧定时器
        if (timer) {
          clearTimeout(timer);
        }
        // 设立新定时器
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      };
    }

    // 滚动加载
    function onScroll() {
      if (loading) {
        let el = document.querySelector(".km_wrapper");
        if (el) {
          var lastBoxDis = el.offsetTop + el.offsetHeight - 300;
          var screenHeight = document.documentElement.clientHeight;
          var scrollTop = document.documentElement.scrollTop;
          timeOut = setTimeout(() => {
            if (lastBoxDis <= screenHeight + scrollTop && loading) {
              page++;
              isLogin();
              // 还原下载按钮样式
              if (
                !$.isEmptyObject(obj) ||
                $(".km_btn").css("opacity") === "0.7"
              ) {
                $(".km_chance").css("display", "block");
              }
              // 将已经点击的图片还原点击状态
              Object.keys(obj).map((item) =>
                $(".km_chance").eq(item).prop("checked", true)
              );
              // 加载后 去掉按钮全选状态
              $(".km_all").prop("checked", false);
            }
          }, 0);
        }
      }
    }
  },
});

          })
        